(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["browiso-offer-b"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const offers = {single:{name:'Single',count:1,total:4990,bonus:'Brow Guide'},duo:{name:'Duo',count:2,total:7990,bonus:'Brow Guide + Beyond the Basics'},trio:{name:'Trio',count:3,total:9980,bonus:'Brow Guide + Beyond the Basics'}};
    const money = (cents) => `A$${(cents / 100).toFixed(2)}`;
    const $ = (selector) => root.querySelector(selector);
    let selected = 'single';
    let bag = null;
    const bagDialog = $('[data-bag-dialog]');
    const guideDialog = $('[data-guide-dialog]');
    const select = (key) => {
      if (!offers[key]) return;
      selected = key;
      const o = offers[key];
      root.querySelectorAll('input[name="ob-set"]').forEach(input => {input.checked = input.value === key;});
      $('[data-preview-add] span').textContent = `Preview ${o.name} in bag`;
      $('[data-cta-price]').textContent = money(o.total);
      $('[data-sticky-title]').textContent = `${o.name} · ${o.count} ${o.count === 1 ? 'kit' : 'kits'}`;
      $('[data-sticky-price]').textContent = money(o.total);
    };
    const updateBag = () => {
      $('[data-bag-count]').textContent = bag ? offers[bag].count : 0;
      $('[data-bag-empty]').hidden = !!bag;
      $('[data-bag-filled]').hidden = !bag;
      if (!bag) return;
      const o = offers[bag];
      $('[data-bag-select]').value = bag;
      $('[data-bag-bonus]').textContent = o.bonus;
      $('[data-kit-count]').textContent = `(${o.count})`;
      $('[data-bag-subtotal]').textContent = money(o.count * 4990);
      $('[data-bag-saving]').textContent = o.count === 1 ? money(0) : `−${money(o.count * 4990 - o.total)}`;
      $('[data-bag-total]').textContent = money(o.total);
      $('[data-upgrade]').hidden = bag === 'trio';
      const next = bag === 'single' ? 'duo' : 'trio';
      $('[data-upgrade-copy]').textContent = `Add one more kit for ${money(offers[next].total - o.total)} more.`;
      $('[data-upgrade-button]').textContent = `Upgrade to ${offers[next].name} ↗`;
    };
    root.querySelectorAll('input[name="ob-set"]').forEach(input => input.addEventListener('change', () => select(input.value)));
    root.querySelectorAll('[data-preview-add]').forEach(button => button.addEventListener('click', () => {bag=selected;updateBag();bagDialog.showModal();}));
    $('[data-open-bag]').addEventListener('click', () => {updateBag();bagDialog.showModal();});
    $('[data-bag-select]').addEventListener('change', event => {bag=event.target.value;select(bag);updateBag();});
    $('[data-upgrade-button]').addEventListener('click', () => {if(!bag || bag === 'trio')return;bag=bag === 'single'?'duo':'trio';select(bag);updateBag();});
    $('[data-remove]').addEventListener('click', () => {bag=null;updateBag();});
    $('[data-select-trio]').addEventListener('click', () => {select('trio');$('#ob-offers').scrollIntoView({block:'center'});});
    root.querySelectorAll('[data-close-dialog]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
    root.querySelectorAll('.ob-dialog').forEach(dialog => dialog.addEventListener('click', event => {if(event.target!==dialog)return;const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();}));
    root.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {const image=button.querySelector('img');$('[data-hero-image]').src=image.src;$('[data-hero-image]').alt=image.alt;root.querySelectorAll('[data-photo]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));
    const guides = {basic:{title:'The Brow Guide',items:['Getting started: your powder and applicator','Shape placement: finding your starting position','A light first application','Blending and correcting the edges']},extended:{title:'Beyond the Basics',items:['Adjusting definition for your everyday routine','Softening the front and defining the tail','Balancing your brow shape','Troubleshooting a finish that looks too dark']}};
    root.querySelectorAll('[data-guide]').forEach(button=>button.addEventListener('click',()=>{const g=guides[button.dataset.guide];$('#ob-guide-title').textContent=g.title;const list=document.createElement('ol');g.items.forEach(text=>{const item=document.createElement('li');item.textContent=text;list.append(item);});$('[data-guide-content]').replaceChildren(list);guideDialog.showModal();}));
    const sticky = $('[data-sticky]');
    const primary = $('[data-preview-add]');
    const syncSticky = () => {sticky.hidden = primary.getBoundingClientRect().bottom >= 0;};
    window.addEventListener('scroll',syncSticky,{passive:true});window.addEventListener('resize',syncSticky);syncSticky();
    select('single');updateBag();
  };
  const run=()=>document.querySelectorAll('[data-offer-b]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.querySelectorAll('[data-native-cart-form]').forEach(form => {
  const update = form.querySelector('[name="update"]');
  update.hidden = true;
  form.querySelectorAll('input[name="updates[]"]').forEach(input => input.addEventListener('change', () => {
    if (form.reportValidity()) form.requestSubmit(update);
  }));
});
const updatePageShipping = async () => {
  const configNode = document.querySelector('[data-offer-test-config]');
  const cartNode = document.querySelector('[data-page-cart]');
  const row = document.querySelector('[data-page-shipping]');
  if (!configNode || !cartNode || !row || !globalThis.BrowisoCheckout) return;
  const config = JSON.parse(configNode.textContent);
  const cart = JSON.parse(cartNode.textContent);
  if (!config.marketSupported || cart.currency !== config.currency || !cart.items.length) return;
  const total = document.querySelector('[data-page-total]');
  const note = document.querySelector('.source-cart-page-note');
  const savings = document.querySelector('[data-page-savings]');
  const previousTotal = total.textContent;
  total.textContent = '…';
  row.hidden = false;
  row.lastElementChild.textContent = '…';
  try {
    const checkout = new globalThis.BrowisoCheckout(config);
    const rate = await checkout.shipping(cart);
    const money = amount => globalThis.BrowisoCheckout.money(amount, cart.currency, document.documentElement.lang || 'en');
    const shippingSaving = checkout.shippingSaving(cart, rate);
    const shippingValue = row.lastElementChild;
    shippingValue.replaceChildren();
    if (shippingSaving > 0) {
      const previous = document.createElement('s');
      previous.textContent = money(config.shippingReference) + ' ';
      shippingValue.append(previous);
    }
    const current = document.createElement('strong');
    current.textContent = rate === 0 ? config.strings.free : money(rate);
    shippingValue.append(current);
    if (savings && shippingSaving > 0) {
      savings.firstElementChild.textContent = savings.dataset.label + ' ' + savings.dataset.inclShipping;
      savings.lastElementChild.textContent = money(Number(savings.dataset.productSaving) + shippingSaving);
    }
    total.textContent = money(cart.total_price + rate) + ' ' + cart.currency;
    note.textContent = config.strings.deliveryNote || config.strings.shippingEstimate;
  } catch {
    row.hidden = true;
    total.textContent = previousTotal;
  }
};
if (!globalThis.BrowisoCheckout) document.addEventListener('DOMContentLoaded', updatePageShipping, { once: true });
else updatePageShipping();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["source-reviews"] && !Shopify.designMode) return;
  try {
    
const deferredReviews = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const frame = entry.target;
    frame.srcdoc = frame.dataset.reviewSrcdoc;
    frame.removeAttribute('data-review-srcdoc');
    deferredReviews.unobserve(frame);
  });
}, {rootMargin:'1000px 0px'});
document.querySelectorAll('iframe[data-review-srcdoc]').forEach(frame => deferredReviews.observe(frame));
document.addEventListener('click',(event)=>{if(event.target.closest('[data-source-review-close]'))event.target.closest('dialog').close();});
window.addEventListener('message',(event)=>{
  const frame=[...document.querySelectorAll('iframe[data-source-reviews]')].find((item)=>item.contentWindow===event.source);
  if(!frame||event.data?.type!=='browfi-reviews')return;
  if(Number.isFinite(event.data.height)&&event.data.height>0&&event.data.height<100000)frame.style.height=`${event.data.height}px`;
  if(event.data.summary&&Number.isInteger(event.data.summary.count)&&event.data.summary.count>0&&Number(event.data.summary.average)>=1&&Number(event.data.summary.average)<=5){
    document.querySelectorAll('[data-gecomo-rating]').forEach((label)=>{label.textContent=Number(event.data.summary.average).toFixed(1)+' / 5 · '+event.data.summary.count.toLocaleString('en-AU')+' reviews';});
  }
  if(event.data.write)document.querySelector('[data-source-review-form]')?.showModal();
  if(event.data.review){
    const review=event.data.review;
    const modal=document.querySelector('[data-source-review-dialog]');
    modal.querySelector('[data-source-review-name]').textContent=review.name;
    const rating=modal.querySelector('[data-source-review-rating]');
    rating.replaceChildren();
    const stars=Math.min(5,Math.max(0,Number(review.rating)||0));
    rating.setAttribute('aria-label',`${stars} out of 5 stars`);
    for(let i=0;i<stars;i++){
      const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');
      const path=document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('fill','currentColor');
      path.setAttribute('d','m12 1 3.4 6.9 7.6 1.1-5.5 5.4 1.3 7.6L12 18.4 5.2 22l1.3-7.6L1 9l7.6-1.1Z');
      svg.append(path);rating.append(svg);
    }
    const date=modal.querySelector('[data-source-review-date]');
    date.textContent=review.date?new Date(review.date).toLocaleDateString():'';
    if(review.date)date.dateTime=new Date(review.date).toISOString();else date.removeAttribute('datetime');
    modal.querySelector('[data-source-review-text]').textContent=review.text;
    const image=modal.querySelector('[data-source-review-image]');
    const media=modal.querySelector('[data-source-review-media]');
    media.hidden=!review.image;
    image.dataset.portrait=String(Number(review.ratio)>1);
    const background=String(review.color||'').match(/rgb\([\d\s,]+\)/)?.[0]||'#eee';
    media.style.setProperty('--review-image-background',background);
    if(review.image){image.src=review.image;image.alt=review.imageAlt||'Customer review photo';}
    modal.showModal();modal.scrollTop=0;
  }
});

  } catch(e) { console.error(e); }
})();
})();
